import { render, staticRenderFns } from "./GuestsRooms.vue?vue&type=template&id=16858c1e"
import script from "./GuestsRooms.vue?vue&type=script&lang=js"
export * from "./GuestsRooms.vue?vue&type=script&lang=js"
import style0 from "./GuestsRooms.vue?vue&type=style&index=0&id=16858c1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports